import produce from "immer";

import validateStep from "./validateStep";

import initStorageLocation, {
  emailFlowStorageLocation,
  getActionName,
} from "../initStorageLocation";

import { WritableDraft } from "immer/dist/internal";
import { Storage } from "@dashboard-v3/api";
import { State } from "../types";
import {
  getCloudStorage as getStorage,
  getEmailFlow,
} from "pages/Rules/Form/context/ruleSelectors";

export type ContentCopyType = "SAME" | "INDIVIDUAL";

export type ChangeContentCopyType = {
  type: "changeContentCopyType";
  payload: ContentCopyType;
};

export function changeContentCopyType(state: State, payload: ContentCopyType) {
  return produce(state, draft => {
    const storage = getStorage(draft.rule);

    storage.syncAllByRule = payload === "SAME";
    draft.steps.target.done = false;

    if (resetStoreId(storage, payload)) {
      storage.storeId = "";
    }

    if (resetManagedIds(storage)) {
      storage.allManagedUserIds = false;
    }

    if (resetStorageLocation(draft, storage)) {
      storage.location = initStorageLocation(
        draft.rule.actionType,
        draft.rule.targetType,
        storage
      );
    }

    if (draft.rule.targetType === "EMAIL_FLOW" && storage.syncAllByRule) {
      const emailFlow = getEmailFlow(draft.rule);
      emailFlow.bidirectional = false;
    }

    validateStep("target", draft);
  });
}

function resetManagedIds(storage: Storage) {
  return storage.syncAllByRule && storage.allManagedUserIds;
}

function resetStoreId(storage: Storage, type: ContentCopyType) {
  return type === "SAME" && storage.storeId && storage.provider !== "DROPBOX";
}

function resetStorageLocation(draft: WritableDraft<State>, storage: Storage) {
  const { actionType } = draft.rule;
  const currentLocation = storage.location;

  if ("copyPolicy" in currentLocation) {
    return false;
  }

  if ("parentId" in currentLocation) {
    return false;
  }

  const actionName = getActionName(actionType);

  const defaultPaths = [
    emailFlowStorageLocation(actionName, true).folderStructure,
    emailFlowStorageLocation(actionName, false).folderStructure,
  ];

  if (!defaultPaths.includes(currentLocation.folderStructure)) {
    return false;
  }

  return true;
}
